import {Controller} from "stimulus"
import intTelInput from 'intl-tel-input'
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = [
    'container',
  ]

  connect() {
    this.iti = intTelInput(this.containerTarget, {
      initialCountry: 'at',
      preferredCountries: ['at', 'de', 'ch'],
      autoHideDialCode: false,
      nationalMode: false,
      // separateDialCode: true,
      // geoIpLookup: function (callback) {
      //   Rails.ajax({
      //     url: "https://ipinfo.io",
      //     type: 'GET',
      //     complete: (resp) => {
      //       let countryCode = (resp && resp.country) ? resp.country : "at";
      //       callback(countryCode)
      //     }
      //   })
      // },
    })
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy()
    }
  }
}
